import { IdentityRef } from "@amzn/altar-sds-client";
import { APIOutput, EmployeeIdentity } from "@amzn/ask-legal-domain";
import { IconProps, StatusIndicator } from "@amzn/awsui-components-react";
import * as React from "react";
import { AppContext } from "../../../setup/context";
import { IdentityLink } from "../../common/IdentityLink";

export function PersonViewComp(props: { identityRef: IdentityRef }) {
    const context = React.useContext(AppContext);
    const [name, setName] = React.useState<string>();
    const [warningIcon, setWarningIcon] = React.useState<IconProps>();

    async function init() {
        const searchResponse = await context.getUserSearchAPI().searchUserByLogin({
            userName: props.identityRef.id,
            limit: 1
        });
        const output = APIOutput.fromRaw<EmployeeIdentity[]>(searchResponse.data);
        if (output.isOk() && output.data.length > 0) {
            setName(output.data[0].name);
            setWarningIcon(undefined);
        } else {
            setWarningIcon({});
        }
    }

    React.useEffect(() => {
        init();
    }, [props.identityRef]);

    const identityComp = <span>
        <IdentityLink id={props.identityRef.id} name={name} />
        {` (${props.identityRef.id})`}
    </span>;

    return <>
        {warningIcon && <StatusIndicator type="warning">{identityComp}</StatusIndicator>}
        {!warningIcon && identityComp}
    </>;
}
